import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthenticationService } from '../../common/services/authentication.service';
import { TicketIdWithCommunity } from '../../common/models/ticket-id-with-community.model';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InlineSVGComponent } from '../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    imports: [TooltipModule, InlineSVGComponent, TranslateModule],
})
export class WelcomeComponent {
    @Input() createdTicketsData: TicketIdWithCommunity[] = [];

    @Output() openForm = new EventEmitter();

    constructor(public authenticationService: AuthenticationService) {}
}
